import { WarningCircle } from '@phosphor-icons/react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ScrollLock } from '@/components/shared/ScrollLock';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto bg-black/40 p-4"
      onClick={onCancel}
    >
      <ScrollLock />
      <div className="flex min-h-full items-center justify-center">
      <Card
        className="w-full max-w-md shadow-pop"
        onClick={(e) => e.stopPropagation()}
      >
        <CardContent className="p-6 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 dark:bg-amber-500/10">
            <WarningCircle className="h-7 w-7 text-amber-500" weight="fill" />
          </div>

          <h3 className="text-base font-semibold text-foreground">{title}</h3>
          <p className="mt-2 text-sm text-muted-foreground">{message}</p>

          <div className="mt-6 flex items-center justify-center gap-3">
            <Button variant="outline" size="md" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="destructive" size="md" onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        </CardContent>
      </Card>
      </div>
    </div>
  );
}
